/*
 *   File : risk-modal.js
 *   Author : https://evoqins.com
 *   Description : risk modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";

/* ---------- Overlay Component ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Modal Component ---------- */
export default function RiskModal({ open = false, data = {}, onClose }) {
  if (!open) return null;

  const { question, answers = [], weight } = data;
  console.log(data);

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onClose} />

      {/* Modal Box */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0"
        style={{ zIndex: 1055, maxWidth: "600px" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{ backdropFilter: "blur(2px)" }}
          className="d-flex flex-column rg-22 justify-content-between bg-white bg-opacity-80 align-items-center border-bottom p-24"
        >
          <div className="d-flex w-100 justify-content-between">
            <h4 className="mb-0 fs-16 fw-500 text-eerie-black">
              View Question
            </h4>

            <PrimaryButton
              icon="close"
              ClassName="bg-transparent p-0"
              onPress={onClose}
            />
          </div>

          <div className="p-24 bg-white rounded-16 bg-opacity-40 w-100">
            {/* Question */}
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column pb-1 border-bottom border-white">
                <h5 className="fw-400 fs-14 lh-18 text-davys-gray">Question</h5>
                <h3 className="fw-500 fs-14 lh-24 text-eerie-black">
                  {question}
                </h3>
              </div>
              <div className="d-flex flex-column pb-1 border-bottom border-white">
                <h5 className="fw-400 fs-14 lh-18 text-davys-gray">
                  Weightage
                </h5>
                <h3 className="fw-500 fs-14 lh-24 text-eerie-black text-end">
                  {weight}
                </h3>
              </div>
            </div>

            {/* Options */}
            <div className="row pt-3">
              <div className="col-8">
                <h4 className="fw-400 fs-14 lh-18 text-davys-gray">Options</h4>
              </div>
              <div className="col-4">
                <h4 className="fw-400 text-end fs-14 lh-18 text-davys-gray">
                  Score Value
                </h4>
              </div>

              {answers.map((item) => (
                <React.Fragment key={item.id}>
                  <div className="col-8">
                    <h4 className="fw-500 fs-14 lh-24 text-eerie-black">
                      {item.label}
                    </h4>
                  </div>
                  <div className="col-4">
                    <h4 className="fw-500 text-end fs-14 lh-24 text-eerie-black">
                      {item.score}
                    </h4>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
}
